import { useEffect, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetPaymentMethodData } from "../../lib/data";
import { paymentMethodColumns } from "../../lib/definitions";

import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import UpdatePayment from "../../ui/Models/updatePayment";
import { updatePaymentMethodForm } from "../../lib/actions";
import { useTranslation } from "react-i18next";


export default function PaymentMethod() {

    const [paymentsData, setPaymentsData] = useState([]);
    const [confirmation, setConfirmation] = useState({ isOpen: false, idToConfirm: null });
    const [loadingConfirm, setLoadingConfirm] = useState(false); 
    const [isLoading, setIsLoading] = useState(true);  
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        setIsLoading(true); 
        const paymentsMethod = await GetPaymentMethodData();
        setPaymentsData([]);
        paymentsMethod.data.map((e) => setPaymentsData((prev) => [...prev, e]));
        setIsLoading(false);  
    };

    const openConfirmation = (id) => {
        setConfirmation({ isOpen: true, idToConfirm: id });
    };

    const closeConfirmation = () => {
        setConfirmation({ isOpen: false, idToConfirm: null });
    };

    const handelConfirm = async (status) => {
        if (confirmation.idToConfirm) {
            setLoadingConfirm(true);
            const result = await updatePaymentMethodForm(confirmation.idToConfirm, status);
            if (result) { 
                handleApi();
            }
            setLoadingConfirm(false);
            closeConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            <h2 className="text-lg text-white pb-4">{t("add_page_title.payment")} </h2>
            <div>
                {isLoading ? <TableSkeleton cols={paymentMethodColumns}/> : (  
                    <Table columns={paymentMethodColumns} rows={paymentsData} openConfirmation={openConfirmation} action={"payment"} />
                )}
            </div>
            {confirmation.isOpen && <UpdatePayment loadingConfirm={loadingConfirm} handelConfirm={handelConfirm} closeConfirmation={closeConfirmation} />}
        </div>
    );
};